import dayjs from 'dayjs';

export default (post, publicHostUrl) => {
  const data = {
    '@type': 'BlogPosting',
    '@id': post.publicUrl,
    mainEntityOfPage: post.publicUrl,
    headline: post.title,
    name: post.title,
    description: post.metaFields.description,
    datePublished: dayjs(post.createdAt ? post.createdAt.timestamp * 1000 : null).format('YYYY-MM-DDTHH:mm:ss+Z'),
    dateModified: dayjs(post.createdAt ? post.createdAt.timestamp * 1000 : null).format('YYYY-MM-DDTHH:mm:ss+Z'),
    author: {
      '@type': 'Person',
      '@id': publicHostUrl,
      url: publicHostUrl,
      name: post.metaFields.metaAuthor,
    },
    url: post.publicUrl,
    keywords: post.metaFields.metaKeywords ? post.metaFields.metaKeywords.split(' ') : [],
  };
  if (post.coverImageGuid) {
    data.image = {
      '@type': 'ImageObject',
      '@id': post.coverImageGuid.url,
      url: post.coverImageGuid.url,
      width: post.coverImageGuid.attributes.width,
      height: post.coverImageGuid.attributes.height,
    };
  }
  return data;
};
